import { put, call, select, takeLatest, debounce } from 'redux-saga/effects';
import {
    GET_TYPING_VEHICLES_REQUEST,
    getVehiclesSuccess,
    getVehiclesFailure,
    GET_VEHICLES_TYPE_REQUEST,
    getVehiclesTypeSuccess,
    getVehiclesTypeFailure,
    GET_VEHICLES_BRAND_REQUEST,
    getvehiclesBrandSuccess,
    getvehiclesBrandFailure,
    GET_VEHICLES_MODEL_REQUEST,
    getvehiclesModelSuccess,
    getvehiclesModelFailure,
    SUBMIT_VEHICLE_FILE_REQUEST,
    submitVehicleFileSuccess,
    submitVehicleFileFailure,
    setVehicleFile
} from '../actions/vehicles';
import { getVehiclesInformation, getVehicles } from '../services/vehicles';
import { showGlobalError } from '../../app/actions/app';
import { accessTokenSelector } from '../../auth/selectors/token';
import { vehiclesSelector } from '../selectors/vehicles';
import { uploadFiles } from '../../shared/services/uploadFiles';
import { putTicket } from '../services/tickets';
import { ticketsSelector } from '../selectors/tickets';
import { cdnGetFilesApiAdmin } from "../../app/conf"

const getVehiclesTypeWorker = function* ({ payload: { filters = {} } = {} } = {}) {
    try {
        const token = yield select(accessTokenSelector);
        const { vehicles_type } = yield select(vehiclesSelector);

        if (!vehicles_type.length) {
            const {
                data: { response }
            } = yield call(getVehiclesInformation, filters, token, true);

            yield put(getVehiclesTypeSuccess(response));
        } else {
            yield put(getVehiclesTypeSuccess(null));
        }
    } catch (err) {
        yield put(getVehiclesTypeFailure(err));
        yield put(showGlobalError(true, err));
    }
};

const getVehiclesBrandWorker = function* ({ payload: { filters = {} } = {} } = {}) {
    try {
        const token = yield select(accessTokenSelector);

        const {
            data: { response }
        } = yield call(getVehiclesInformation, filters, token);

        yield put(getvehiclesBrandSuccess(response.Marca));
    } catch (err) {
        yield put(getvehiclesBrandFailure(err));
        yield put(showGlobalError(true, err));
    }
};

const getVehiclesModelWorker = function* ({ payload: { filters = {} } = {} } = {}) {
    try {
        const token = yield select(accessTokenSelector);

        const {
            data: { response }
        } = yield call(getVehiclesInformation, filters, token);

        yield put(getvehiclesModelSuccess(response.Modelo));
    } catch (err) {
        yield put(getvehiclesModelFailure(err));
        yield put(showGlobalError(true, err));
    }
};

const submitVehicleFileWorker = function* ({ payload: { vehicle_file = {}, type } = {} } = {}) {
    try {
        const token = yield select(accessTokenSelector);

        const { data: { path } } = yield call(uploadFiles, vehicle_file, token);

        const { ticket: ticketAccesor } = yield select(ticketsSelector);

        const ticket = {
            status: ticketAccesor.status._id,
            _id: ticketAccesor._id,
            vehicle: {
                image: JSON.stringify([path])
            }
        };

        yield call(putTicket, ticket, type, token);

        yield put(submitVehicleFileSuccess());
        yield put(setVehicleFile(cdnGetFilesApiAdmin(path)));

    } catch (err) {
        yield put(submitVehicleFileFailure(err));
        yield put(showGlobalError(true, err));
    }
};

const getVehiclesWorker = function* ({ payload: { filters = {} } = {} } = {}) {
    try {

        const token = yield select(accessTokenSelector);

        const {
            data: { vehicles }
        } = yield call(getVehicles, filters, token);

        yield put(getVehiclesSuccess(vehicles));

    } catch (error) {
        yield put(getVehiclesFailure(error));
        yield put(showGlobalError(true, error));
    }
}

export default [
    debounce(500, GET_TYPING_VEHICLES_REQUEST, getVehiclesWorker),
    takeLatest(GET_VEHICLES_TYPE_REQUEST, getVehiclesTypeWorker),
    takeLatest(GET_VEHICLES_BRAND_REQUEST, getVehiclesBrandWorker),
    takeLatest(GET_VEHICLES_MODEL_REQUEST, getVehiclesModelWorker),
    takeLatest(SUBMIT_VEHICLE_FILE_REQUEST, submitVehicleFileWorker)
];
